<template>
  <div class="dashboard">
    <AppHeader />
    <router-view />
    <AppNav />
  </div>
</template>

<script>

import AppHeader from '@/components/AppHeader'
import AppNav from '@/components/AppNav'
export default {
  components: {
    AppHeader, AppNav
  }
}
</script>
